import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import axios from "../../api/axios";
import { useAuth } from "../../hooks/useAuth";
import "react-toastify/dist/ReactToastify.css";
const LOGIN_URL = `cbt-centers/login`;

const Login = () => {
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const [centerLoginData, setCenterLoginData] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    setAuth({});
  }, []);

  async function centerLogin(e) {
    e.preventDefault();
    const id = toast.loading("Signing in, please wait...");

    try {
      const response = await axios.post(LOGIN_URL, centerLoginData, {
        headers: {
          "Content-Type": "application/json",
          Accept: "*",
        },
      });

      const { name, token: access_token, phone_number, email, referral_code, id } = response?.data?.data;

      setAuth({ id, name, access_token, phone_number, email, referral_code });

      toast.update(id, {
        render: response.data.message || "Login Successful",
        type: "success",
        isLoading: false,
        autoClose: 1000,
      });

      setTimeout(() => {
        toast.update(id, {
          render: "Directing to dashboard",
          type: "info",
          isLoading: false,
          autoClose: 1000,
        });
      }, 1300);

      setTimeout(() => {
        navigate("/centers/dashboard");
      }, 2600);
    } catch (err) {
      console.log(err);
      setCenterLoginData({
        email: "",
        password: "",
      });
      toast.update(id, {
        render: err.response?.data?.message || err.message || "An error occurred",
        type: "error",
        isLoading: false,
        autoClose: 1000,
      });
    }
  }

  return (
    <>
      <ToastContainer />
      <div className="auth-page-wrapper pt-5">
        {/* auth page bg */}
        {/* <div className="auth-one-bg-position auth-one-bg" id="auth-particles"> */}
        <div className="auth-one-bg-position" id="auth-particles">
          <div className="bg-overlay"></div>

          <div className="shape">
            {/* <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1440 120">
                    <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
                </svg> */}
          </div>
        </div>

        {/* auth page content */}
        <div className="auth-page-content">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="text-center mt-sm-5 mb-4 text-white-50">
                  <div>
                    <a href="index.html" className="d-inline-block auth-logo">
                      <img src="assets/images/card-a1tutor.png" alt="" height="30" />
                    </a>
                  </div>
                  {/* <p className="mt-3 fs-15 fw-medium">Premium Admin & Dashboard Template</p> */}
                </div>
              </div>
            </div>
            {/* end row */}

            <div className="row justify-content-center">
              <div className="col-md-8 col-lg-6 col-xl-5">
                <div className="card mt-4">
                  <div className="card-body p-4 pb-5">
                    <div className="text-center mt-2">
                      <h5 className="text-primary">Welcome Back Admin!</h5>
                      <p className="text-muted">Sign in to continue to dashboard.</p>
                    </div>
                    <div className="p-2 mt-4">
                      <form onSubmit={centerLogin}>
                        <div className="mb-3">
                          <label htmlFor="email" className="form-label">
                            Email
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="email"
                            placeholder="Enter email"
                            value={centerLoginData?.email}
                            onChange={(e) =>
                              setCenterLoginData({
                                ...centerLoginData,
                                email: e.target.value,
                              })
                            }
                          />
                        </div>

                        <div className="mb-3">
                          {/* <div className="float-end">
                                                <a href="auth-pass-reset-basic.html" className="text-muted">Forgot password?</a>
                                            </div> */}
                          <label className="form-label" htmlFor="password-input">
                            Password
                          </label>
                          <div className="position-relative auth-pass-inputgroup mb-3">
                            <input
                              type={showPassword ? "text" : "password"}
                              className="form-control pe-5"
                              placeholder="Enter password"
                              id="password-input"
                              value={centerLoginData?.password}
                              onChange={(e) =>
                                setCenterLoginData({
                                  ...centerLoginData,
                                  password: e.target.value,
                                })
                              }
                            />
                            <button
                              className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                              type="button"
                              id="password-addon"
                              onClick={() => setShowPassword((prev) => !prev)}
                            >
                              <i className="ri-eye-fill align-middle"></i>
                            </button>
                          </div>
                        </div>

                        {/* <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id="auth-remember-check" />
                                            <label className="form-check-label" htmlFor="auth-remember-check">Remember me</label>
                                        </div> */}

                        <div className="mt-4">
                          <button className="btn btn-success w-100" type="submit">
                            Sign In
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  {/* end card body */}
                </div>
                {/* end card */}

                <div className="mt-4 text-center">
                  <p className="mb-0">&copy; 2023 A1tutor</p>
                </div>
              </div>
            </div>
            {/* end row */}
          </div>
          {/* end container */}
        </div>
        {/* end auth page content */}
      </div>
    </>
  );
};

export default Login;
